import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="min-h-[calc(100vh-68px)] flex items-center justify-center px-6">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="text-center max-w-md">
        <XCircle size={56} className="text-white/40 mx-auto mb-6" />
        <h1 className="font-serif-display font-light text-white text-4xl md:text-5xl tracking-tight">Pagamento Cancelado</h1>
        <p className="text-white/50 font-light mt-4">Sua sacola foi mantida. Você pode finalizar a compra quando quiser.</p>
        <Link to="/loja" className="inline-block mt-10 border border-white/25 hover:border-white text-white px-8 py-4 label-caps transition-colors duration-300">Voltar à Loja</Link>
      </motion.div>
    </div>
  );
}
